export default __webpack_public_path__ + "static/media/releases.12b6688a.png";